import {fetchAppointments} from "./appointment";

export default fetchAppointments